/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';
import type { OAuthProvider } from './OAuthProvider';
import {
    OAuthProviderFromJSON,
    OAuthProviderFromJSONTyped,
    OAuthProviderToJSON,
} from './OAuthProvider';
import type { OIDCGroupsOptions } from './OIDCGroupsOptions';
import {
    OIDCGroupsOptionsFromJSON,
    OIDCGroupsOptionsFromJSONTyped,
    OIDCGroupsOptionsToJSON,
} from './OIDCGroupsOptions';
import type { OIDCUXMode } from './OIDCUXMode';
import {
    OIDCUXModeFromJSON,
    OIDCUXModeFromJSONTyped,
    OIDCUXModeToJSON,
} from './OIDCUXMode';

/**
 * 
 * @export
 * @interface OIDCMethodOptions
 */
export interface OIDCMethodOptions {
    /**
     * 
     * @type {FactorMethod}
     * @memberof OIDCMethodOptions
     */
    method: FactorMethod;
    /**
     * 
     * @type {string}
     * @memberof OIDCMethodOptions
     */
    client_id: string;
    /**
     * 
     * @type {OAuthProvider}
     * @memberof OIDCMethodOptions
     */
    provider: OAuthProvider;
    /**
     * 
     * @type {OIDCUXMode}
     * @memberof OIDCMethodOptions
     * @deprecated
     */
    ux_mode?: OIDCUXMode;
    /**
     * URL to redirect to after login at the third-party IdP.
     * @type {string}
     * @memberof OIDCMethodOptions
     */
    redirect_target?: string;
    /**
     * 
     * @type {OIDCGroupsOptions}
     * @memberof OIDCMethodOptions
     */
    requires_groups?: OIDCGroupsOptions;
    /**
     * 
     * @type {string}
     * @memberof OIDCMethodOptions
     */
    pkce_code_challenge?: string;
    /**
     * 
     * @type {string}
     * @memberof OIDCMethodOptions
     */
    csrf_token?: string;
}

/**
 * Check if a given object implements the OIDCMethodOptions interface.
 */
export function instanceOfOIDCMethodOptions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "method" in value;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "provider" in value;

    return isInstance;
}

export function OIDCMethodOptionsFromJSON(json: any): OIDCMethodOptions {
    return OIDCMethodOptionsFromJSONTyped(json, false);
}

export function OIDCMethodOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OIDCMethodOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'method': FactorMethodFromJSON(json['method']),
        'client_id': json['client_id'],
        'provider': OAuthProviderFromJSON(json['provider']),
        'ux_mode': !exists(json, 'ux_mode') ? undefined : OIDCUXModeFromJSON(json['ux_mode']),
        'redirect_target': !exists(json, 'redirect_target') ? undefined : json['redirect_target'],
        'requires_groups': !exists(json, 'requires_groups') ? undefined : OIDCGroupsOptionsFromJSON(json['requires_groups']),
        'pkce_code_challenge': !exists(json, 'pkce_code_challenge') ? undefined : json['pkce_code_challenge'],
        'csrf_token': !exists(json, 'csrf_token') ? undefined : json['csrf_token'],
    };
}

export function OIDCMethodOptionsToJSON(value?: OIDCMethodOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'method': FactorMethodToJSON(value.method),
        'client_id': value.client_id,
        'provider': OAuthProviderToJSON(value.provider),
        'ux_mode': OIDCUXModeToJSON(value.ux_mode),
        'redirect_target': value.redirect_target,
        'requires_groups': OIDCGroupsOptionsToJSON(value.requires_groups),
        'pkce_code_challenge': value.pkce_code_challenge,
        'csrf_token': value.csrf_token,
    };
}

